import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
// routes
import { routes } from './routes';
// theme
import ThemeProvider from './theme';
// redux
import { getUserProfile } from './redux/profile/profileSlice';
import { logOutUser, selectAuthData } from './redux/auth/authSlice';
import { getCountries } from './redux/other/otherSlice';
import { getUserHistory } from './redux/history/historySlice';
// components
import { StyledChart } from './components/chart';
import { isTokenExpired } from './utils/checkTokenValidity';

// ----------------------------------------------------------------------

export default function App() {
  const dispatch = useDispatch();

  const userData = useSelector(selectAuthData);

  useEffect(() => {
    dispatch(getCountries());

    const tokenExpiryResponse = isTokenExpired(userData);

    if (tokenExpiryResponse && tokenExpiryResponse !== 'no-token') {
      dispatch(logOutUser());
    }

    if (!tokenExpiryResponse) {
      dispatch(getUserProfile());
      dispatch(getUserHistory());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <RouterProvider router={routes}>
          <StyledChart />
        </RouterProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}
